import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/group.svg'


const _hoisted_1 = { class: "survey-end-page" }
const _hoisted_2 = { class: "survey-end" }
const _hoisted_3 = { class: "survey-end-title" }
const _hoisted_4 = { class: "survey-end-subtitle" }
const _hoisted_5 = { class: "survey-end-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "survey-end-pic" }, [
        _createElementVNode("img", {
          class: "pic",
          src: _imports_0,
          alt: ""
        })
      ], -1)),
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('callend_01')), 1),
      _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t('callend_02')), 1)
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_Button, {
        class: "survey-end-footer-button",
        size: 'large',
        text: _ctx.$t('go to my page'),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gotoHome()))
      }, null, 8, ["text"])
    ])
  ]))
}